import React from 'react'

import Inspection from './OverAll/Inspection'
import Ticket from './OverAll/Ticket'
import Contracts from './OverAll/contract'
import OverView from './OverAll/OverView'
import Recent from './OverAll/Recent'
import Upcoming from './OverAll/Upcoming'
import Renewal from './OverAll/Renewal'
import Client from './OverAll/Client'
import OpenTicket from './OverAll/OpenTicket'
import MonthlyWise from './OverAll/MonthlyWise'
import InvoiceYear from './OverAll/InvoiceYear'
import InvoiceDue from './OverAll/InvoiceDue'
import OpenTask from './OverAll/OpenTask'
import TestingCom from './OverAll/TestingCom'
import Refilling from './OverAll/Refilling'

function Dashboard() {
  return (
    <div className="w-[100%] h-[calc(100vh-145px)] py-0.5  ">
      
{/* <div className="grid grid-cols-6 grid-rows-5 gap-4">
    <div className="col-span-2"><Inspection/></div>
    <div className="col-span-2 col-start-3"><Ticket/></div>
    <div className="col-span-2 col-start-5"><Contracts/></div>
    <div className="col-span-3 row-span-2 row-start-2"><OverView/></div>
    <div className="col-span-3 row-span-2 col-start-4 row-start-2"><Recent/></div>
    <div className="col-span-3 row-span-2 row-start-4"></div>
    <div className="col-span-3 row-span-2 col-start-4 row-start-4"><Renewal/></div>
</div> */}

{/* <div className="grid grid-cols-8  gap-4">
    <div className="col-span-8 md:col-span-4 lg:col-span-2"><Client/></div>
    <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-3"><Inspection/></div>
    <div className="col-span-8 md:col-span-4 lg:col-span-2  lg:col-start-5"><Ticket/></div>
    <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-7"><Contracts/></div>
    <div className="col-span-8 lg:col-span-5 "><OverView/></div>
    <div className="col-span-8 lg:col-span-3  lg:col-start-6 "><Upcoming/></div>
    <div className="col-span-8 lg:col-span-2  "><OpenTask/></div>
    <div className="col-span-8 lg:col-span-6  lg:col-start-3 "><MonthlyWise/></div>
    <div className="col-span-8 lg:col-span-3  "><InvoiceYear/></div>
    <div className="col-span-8 lg:col-span-5  lg:col-start-4 "><InvoiceDue/></div>
    <div className="col-span-8 lg:col-span-2  "><OpenTicket/></div>
    <div className="col-span-8 lg:col-span-4  lg:col-start-3 "><TestingCom/></div>
    <div className="col-span-8 lg:col-span-2  lg:col-start-7 "><Refilling/></div>
    

</div> */}


<div className="grid grid-cols-8  gap-4">
    <div className="col-span-2"><Inspection/></div>
    <div className="col-span-2 col-start-3"><Ticket/></div>
    <div className="col-span-4 col-start-5"><Refilling/></div>
    <div className="col-span-5 "><OverView/></div>
    <div className="col-span-3  col-start-6 "><Upcoming/></div>
    <div className="col-span-3 "><InvoiceYear/></div>
    <div className="col-span-3 col-start-4 "><InvoiceDue/></div>
    <div className="col-span-2  col-start-7"><OpenTicket/></div>
</div>
    
    
{/* <div className="grid grid-cols-8 grid-rows-5 gap-4">
    <div className="col-span-2">1</div>
    <div className="col-span-2 col-start-3">2</div>
    <div className="col-span-4 col-start-5">3</div>
    <div className="col-span-5 row-span-2 row-start-2">4</div>
    <div className="col-span-3 row-span-2 col-start-6 row-start-2">5</div>
    <div className="col-span-3 row-span-2 row-start-4">6</div>
    <div className="col-span-3 row-span-2 col-start-4 row-start-4">7</div>
    <div className="col-span-2 row-span-2 col-start-7 row-start-4">8</div>
</div>
     */}
   
    
    </div>
  )
}

export default Dashboard
